
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { FormItemProps } from ".";
import { loading, update } from "store/form";
import { AppMessage } from "components";

interface ApiFormUpdateInputProps extends FormItemProps {
}

type ApiFormUpdateOutputProps = OutputBaseProps<{ item: FormItemProps; }, ApiFormUpdateInputProps>

export const apiFormUpdate = async (data: ApiFormUpdateInputProps) => {
    store.dispatch(loading());
    const res = (await axios.put<ApiFormUpdateOutputProps>("/api/form/update", data))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(update({ data: res.data.item }));
        AppMessage.success({
            title: "Thông báo",
            message: res.message
        })
    }
    return res;
};